import defaultConfig from "@App/configs/default";
import { PureComponent, ReactNode } from "react";

export type FooterProps = {
  /** Renders the b2c (repareo.de) branding instead of the default b2b one. */
  b2c?: boolean;
  privacyPolicyUrl?: string;
};

export class Footer extends PureComponent<FooterProps> {
  render(): ReactNode {
    const repareoUrl = this.props.b2c ? "https://www.repareo.de/" : "https://www.repareo.com/";
    const logo = this.props.b2c ? "/images/brand/logo-dark.svg" : "/images/brand/logoWhite.svg";
    const copyright = this.props.b2c ? "repareo.de" : "repareo.com";

    return (
      <div className="md:h-20 bg-neutral-700 text-white text-sm p-5">
        <div className="container h-full md:flex items-center justify-between">
          <div className="flex justify-center items-center mb-6 md:mb-0">
            <a href={repareoUrl} target="_blank">
              <img src={logo} className="w-32 h-auto" alt="" />
            </a>
          </div>
          <div className="md:flex gap-3 grid grid-cols-2 justify-between items-center mb-6 md:mb-0">
            <a
              href="https://www.repareo.de/impressum/"
              target="_blank"
              className="text-white no-underline font-normal hover:underline"
            >
              Impressum
            </a>
            <a
              href={this.props.privacyPolicyUrl ?? defaultConfig.legal.privacyPolicyUrl}
              target="_blank"
              className="text-white no-underline font-normal hover:underline"
            >
              Datenschutzerklärung
            </a>
            <a
              href="https://www.repareo.de/haftungsausschluss/"
              target="_blank"
              className="text-white no-underline font-normal hover:underline"
            >
              Haftungsausschluss
            </a>
            <a
              href="https://lp.repareo.de/ws/registrierung-ihrer-werkstatt"
              target="_blank"
              className="text-white no-underline font-normal hover:underline"
            >
              Werkstatt eintragen
            </a>
          </div>
          <div className="flex justify-center items-center">
            <a
              href={repareoUrl}
              target="_blank"
              className="text-white no-underline font-normal hover:underline"
            >
              © {new Date().getFullYear()} {copyright}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
